import { ofType } from 'redux-observable';
import { 
    map, 
    mergeMap,
    flatMap 
} from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET,
    SETSELECTED_ATHENA
} from 'one-state-subject/src/types';

import {
    setAction, 
    resetAction
} from 'one-state-activeproblems/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';

export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Active Problems
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchActiveProblemAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            athenaendpoints: { activeproblems },
            servers,
            uisettings: {
                dashboardapiconfig: {
                    activeproblems: activeproblemsApi
                }
            },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;

        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_ATHENA),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                let payload: any = action.payload;
                const postActiveProblem = (activeprobrequest: any) => {
                    if (activeprobrequest?.id) {
                        let headers = new Headers();

                        const data = {
                            "PatientID": activeprobrequest.id.toString(),
                        }

                        let responseFromPost;
                        responseFromPost = server.post({
                            headers: headers,
                            path: activeproblems,
                            data: data,
                        })
                            .then((responseforap: any) => responseforap)
                            .catch((activeproblemerror: any) => {
                                log.error(
                                    "ccw-gadget,activeproblems-athena",
                                    "active problems-athena", {
                                    activeproblemerror
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "ActiveProblems",
                                    type: "error",
                                    status: activeproblemerror?.status,
                                    erroritems: activeproblemerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,activeproblems-athena",
                            "activeproblems-athena response", {
                            responseFromPost
                        });
                        return from(responseFromPost)
                    } else {
                        return from([]);
                    }
                }
                //Calling getReqeust function here
                //the reason is we need to use pipe function.
                if (!activeproblemsApi) return []
                return postActiveProblem(payload).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.activeproblems)
                            ];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1005" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = payload.id;
                                disp.meta03 = response.error.status;
                                disp.meta04 = response.error.erroritems?.[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "188" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let skillName = sessionStorage.getItem("skillName");
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = payload.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

/**
 * Listen for component clear and intiate state clear for Active Problems
 * @param context  contains logger which is used for logging
 */
export const clearActiveProblemAthena = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, activeproblems-athena",
            "clear-activeproblems-athena", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED_ATHENA, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )
    }
);
